var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_849_",
    d: "M9.2,7.9H6.8H5.5H3.1C2.9,7.9,2.7,8,2.7,8.2v0.7c0,0.2,0.2,0.3,0.3,0.3h2.4v8.2H3.1 c-0.2,0-0.3,0.2-0.3,0.3v0.7c0,0.2,0.2,0.3,0.3,0.3h6.2c0.2,0,0.3-0.2,0.3-0.3v-0.7c0-0.2-0.2-0.3-0.3-0.3H6.8V9.2h2.4 c0.2,0,0.3-0.2,0.3-0.3V8.2C9.6,8,9.4,7.9,9.2,7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_854_",
    d: "M24.6,3.8H1.4C0.6,3.8,0,4.4,0,5.1v15.7c0,0.8,0.6,1.4,1.4,1.4h23.3c0.8,0,1.4-0.6,1.4-1.4V5.1 C26,4.4,25.4,3.8,24.6,3.8z M1.4,20.9V5.1h23.3l0,15.7H1.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbox);
export default __webpack_public_path__ + "static/media/Textbox.3fd2945dbae219190befb024894846c4.svg";
export { ForwardRef as ReactComponent };